module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_internet_browsing-9837d726ea5d7b7713d2d8a16404c397.svg";